document.addEventListener('DOMContentLoaded', async () => {
  const contactForm = document.getElementById('ContactForm');
  const formStatus = document.querySelector('.form-status');
  // count the number of character and display the remaining character number
  const contactFormBody = document.getElementById('ContactForm-body');
  contactFormBody.addEventListener('input', () => {
    const inputCharCount = contactFormBody.value.trim().length;
    const displayCount = 800 - inputCharCount;
    document.querySelector('.remaining-count').innerHTML = displayCount;
  });

  if (contactForm) {
    contactForm.addEventListener('change', (e) => {
      toggleMessage(e.target, '');
      inputValidation(e.target);
    });
    contactForm.addEventListener('input', (e) => toggleMessage(e.target, ''));
    contactForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const formData = new FormData(contactForm);
      const canSubmit = Array.from(contactForm.querySelectorAll('input[name]:not([type="radio"]), textarea[name]'))
        .map((input) => inputValidation(input))
        .every((i) => i);
      if (canSubmit) {
        if (window.form_url && contactForm.dataset.hulkFormId.length > 0 && contactForm.dataset.apiToken.length > 0) {
          const data = {
            form_uuid: contactForm.dataset.hulkFormId,
            email_check: formData.get('contact[email]'),
            confirmationMail: formData.get('contact[email]'),
            formResponse: {
              'Email (メールアドレス)': formData.get('contact[email]'),
              'お名前 (氏名)': formData.get('contact[名前]'),
              お問い合わせの内容: formData.get('contact[enquiry]'),
              'お問い合わせ内容を入力してください（半角で800文字まで入力可能です）': formData.get('contact[コメント]'),
              '注文番号(わかる場合)': formData.get('contact[order_number]'),
              '電話番号 (ハイフンなし)': formData.get('contact[電話番号]'),
            },
          };
          contactForm.classList.add('loading');
          fetch(`${window.form_url}/forms/create_response/${contactForm.dataset.hulkFormId}`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Form-Access-Token': contactForm.dataset.apiToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          })
            .then((response) => {
              if (!response.ok) {
                switch (response.status) {
                  case 400:
                    console.error('Bad Request -- Your request is invalid.');
                    break;
                  case 401:
                    console.error('Unauthorized -- Your API key is wrong.');
                    break;
                  case 403:
                    console.error('Forbidden -- The requested is hidden for administrators only.');
                    break;
                  case 404:
                    console.error('Not Found -- The specified data could not be found.');
                    break;
                  case 500:
                    console.error('Internal Server Error -- We had a problem with our server. Try again later.');
                    break;
                  case 503:
                    console.error(`Service Unavailable -- We're temporarily offline for maintenance. Please try again later.`);
                    break;
                }
                console.error(`https://formbuilder.hulkapps.com/api-docs/index.html`);
              }
              return response.json();
            })
            .then((responseData) => {
              if (deepEqual(responseData, data.formResponse)) {
                contactForm.classList.add('success');
              } else {
                if (responseData.validate === false) {
                  alert('入力内容が正しくありません。もう一度確認してください。');
                } else if (responseData.message === 'Access denied') {
                  alert('アクセスが拒否されました。');
                } else {
                }
              }
            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              contactForm.classList.remove('loading');
            });
        } else {
          contactForm.submit();
        }
      } else {
        scrollToError();
        throw new Error('Form validation failed');
      }
    });
  }
  function deepEqual(objA, objB) {
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    return keysA.every((key) => objB.hasOwnProperty(key) && objA[key] === objB[key]);
  }
  function scrollToError() {
    const firstErrorElement = document.querySelector('.error-message:not(:empty)');
    if (firstErrorElement) {
      firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function toggleMessage(input, message = false) {
    const elmField = input.closest('.field-wrapper');
    const elmMessage = elmField ? elmField.querySelector('.error-message') : null;
    if (!elmField && !elmMessage) return true;
    if (elmMessage) elmMessage.innerHTML = message ? message : '';
    const borderAlert = elmField.querySelector('.border-alert') || input;
    borderAlert.classList.toggle('red-border', message);
  }

  function inputValidation(input) {
    toggleMessage(input, '');
    if (input.required) {
      if (input.value.length == 0 && input.name.includes('enquiry')) {
        toggleMessage(input, 'お問い合わせ内容を選択してください。');
        return false;
      }
      if (input.value.length == 0 || (input.type === 'checkbox' && !input.checked)) {
        toggleMessage(input, window?.accountErrorStrings?.required || 'この項目は必須です。');
        return false;
      }
    }
    if (input.type == 'email' && !emailValidation(input)) {
      toggleMessage(input, window?.accountErrorStrings?.emailError || '正しいメールアドレスを入力してください。');
      return false;
    }
    if (input.type == 'tel' && !phoneValidation(input)) {
      toggleMessage(input, window?.accountErrorStrings?.phoneError || '正しい電話番号を入力して下さい。');
      return false;
    }
    return true;
  }

  function emailValidation(input) {
    const emailRegex = window?.regex?.email;
    return emailRegex.test(input.value);
  }

  function phoneValidation(input) {
    const phoneRegex = /^0\d{9,10}$/;
    return phoneRegex.test(input.value);
  }
});
